<template>
  <div id="absenteeismIndex" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">

      <header-v2 title="Gestión de la Información ausentismos" />
      <div class="row">
        <div class="col-12 mt-4">
          <AbsFilters
              @change:operations="changedOperations"
              @change:sites="changedSites"
              @change:reasonNames="changedReasonNames"
              @change:date="changedDate"
              @change:employees="changedEmployees"
              @click:forgetFilter="forgetFilters"
              :errors="errors"/>
        </div>
        <div class="col-12">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Diagnósticos" active>
                <b-card-text>
                  <template v-if="processingTotalRecorded">
                    <b-col cols="1" class="text-center mt-5">
                      Cargando...
                    </b-col>
                  </template>
                  <template v-else>
                    <div class="content-total">
                      <b-col cols="12">
                        Total de ausentimos registrados: {{ getTotalRecorded }}
                      </b-col>
                    </div>
                  </template>
                  <template v-if="processingDiagnosticGroup">
                    <b-col cols="12" class="text-center">
                      Cargando...
                    </b-col>
                  </template>
                  <template v-else>
                    <template v-if="is_visible_diagnostic_groups">
                      <div class="content-generic pb-4">
                        <span>
                          Selecciona algún diagnóstico
                        </span>
                        <DiagnosticGraph
                            :diagnostics="getDiagnosticGroups"
                            @clicked:diagnostic="clickInDiagnostic"/>
                      </div>
                      <div class="content-generic">
                        <TableInformationAbs
                            :dataOfTable="getDiagnosticGroupEmployees"
                            :processing="processingDiagnosticGroupsTable"
                            @clicked:diagnosticGroup="changedPageDiagnosticGroupsTable"/>
                      </div>
                    </template>
                    <template v-else-if="conditions.key">
                      <b-col cols="12" class="text-center pb-4">
                        {{ conditions.msj }}
                      </b-col>
                    </template>
                  </template>
                </b-card-text>
              </b-tab>
              <b-tab title="Tipo de ausentismos">
                <b-card-text>
                    <template v-if="isVisibleTypeAbsenteeism">
                      <div class="content-generic">
                        <TypeAbsenteeism
                            :totalAbsenteeism="getTypesAbsenteeism"
                            :loading="processingTypeAbsenteeism"
                            @clicked:absenteeism="clickInAbsenteeism"
                        />
                      </div>
                      <div class="content-generic">
                        <TableInformationAbs
                            :dataOfTable="getTypesAbsenteeismEmployees"
                            :processing="processingTypeAbsenteeismTable"
                            @change:page="changedPageTypeAbsenteeismTable"/>
                      </div>
                    </template>
                    <template v-else>
                      <template v-if="conditionsNoExist(isVisibleTypeAbsenteeism, processingTypeAbsenteeism).key">
                        <b-col cols="12" class="text-center mt-5">
                          {{ conditionsNoExist(isVisibleTypeAbsenteeism, processingTypeAbsenteeism).msj }}
                        </b-col>
                      </template>
                    </template>
              </b-card-text>
              </b-tab>
              <b-tab title="Emisor de ausencia">
                <b-card-text>
                  <template v-if="isVisibleAbsenceSenders">
                    <div class="content-generic">
                      <TypeAbsenteeism
                          :totalAbsenteeism="getAbsenceSenders"
                          :loading="processingAbsenceSender" />
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="conditionsNoExist(isVisibleAbsenceSenders, processingAbsenceSender).key">
                      <b-col cols="12" class="text-center mt-5">
                        {{ conditionsNoExist(isVisibleAbsenceSenders, processingAbsenceSender).msj }}
                      </b-col>
                    </template>
                  </template>
                </b-card-text>
              </b-tab>
              <b-tab title="Tiempo de ausencia">
                <b-card-text>
                  <template v-if="isVisibleLostTimeAbsenteeism">
                    <div class="content-generic">
                      <b-row class="justify-content-md-center">
                        <b-col cols="8">
                          <bar-chart
                              :chart-data="chart_data"
                              :options="chart_options"
                              :width="800"
                              :height="400"/>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="conditionsNoExist(isVisibleLostTimeAbsenteeism, processing_lost_time).key">
                      <b-col cols="12" class="text-center mt-5">
                        {{ conditionsNoExist(isVisibleLostTimeAbsenteeism, processing_lost_time).msj }}
                      </b-col>
                    </template>
                  </template>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions
  ,mapGetters
} from 'vuex'


import AbsFilters from "@/components/Modules/HealthTracker/V2/Absenteeism/InformationManagement/AbsFilters";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2";
import HeadingUser from "@/components/user/HeadingUser";
import TypeAbsenteeism from "@/components/Modules/HealthTracker/V2/Absenteeism/InformationManagement/TypeAbsenteeism";
import TableInformationAbs from "@/components/Modules/HealthTracker/V2/Absenteeism/InformationManagement/TableInformationAbs";
import DiagnosticGraph from "@/components/Modules/HealthTracker/V2/Absenteeism/InformationManagement/DiagnosticGraph";
export default {
  name: "absenteeismIndex",
  components: {
    TypeAbsenteeism,
    MainBarMenuV2,
    HeadingUser,
    AbsFilters
    , TableInformationAbs
    , DiagnosticGraph
    , HeaderV2: () => import('@/components/common/header/HeaderV2.vue')
    , BarChart: () => import('@/components/charts/BarChart.js')
  },
  data: () => ({
    operations: []
    , sites: []
    , reasonNames: []
    , employees: []
    , date: {
      start: null,
      end: null
    }
    , processingTypeAbsenteeism: true
    , reasonNamesTypeAbsenteeism: []
    , processingAbsenceSender: true
    , errors: []
    , processingTypeAbsenteeismTable: false
    , processingTotalRecorded: true
    , diagnosticGroupsSelected: []
    , processingDiagnosticGroupsTable: false
    , processingDiagnosticGroup: false
    , processing_lost_time: true
  })
  ,computed: {
    chart_options () {
      return {
        responsive: true
        , type: 'horizontalBar'
        , legend: {
          labels: {
            boxWidth: 12
            , fontSize: 12
            , padding: 30
          }
        }
        , scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
          , yAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    }
    , chart_data () {
      return {
        labels: this.getKeyLostTimes()
        , datasets: [
            {
              label: 'Días perdidos'
              , data: this.getKeyLostTimes('lost_days')
              , backgroundColor: '#459BFF'
              , categoryPercentage: 0.8
              , padding: 1
            }
            , {
            label: 'Horas perdidas'
            , backgroundColor: '#1719DA'
            , data: this.getKeyLostTimes('lost_hours')
            , categoryPercentage: 0.8,
          }
        ]
      }
    }
    , isVisibleTypeAbsenteeism () {
       return !!(this.getTypesAbsenteeism.length)
    }
    , isVisibleAbsenceSenders () {
      return !!(this.getAbsenceSenders.length)
    }
    , isVisibleLostTimeAbsenteeism () {
      return !!(this.getLostTimes.length)
    }
    , is_visible_diagnostic_groups () {
      return !!(this.getDiagnosticGroups.length)
    }
    , exists_date () {
      return !!(this.date.end && this.date.start)
    }
    , conditions () {
      if(!this.is_visible_diagnostic_groups && this.exists_date) return { key: !this.is_visible_diagnostic_groups, msj: 'No hay información' }
      return { key: true, msj: 'Por favor seleccione las  fechas' }
    }
    , ...mapGetters('healthTrackerAbsenteeismV2InformationManagementGraphic', [
        'getTypesAbsenteeism'
        , 'getAbsenceSenders'
        , 'getTypesAbsenteeismEmployees'
        , 'getTotalRecorded'
        , 'getDiagnosticGroups'
        , 'getDiagnosticGroupEmployees'
        , 'getLostTimes'
    ])
    ,listFilters () {
      return [
        {
          name: 'sites'
          , values: this.sites
        }
        ,{
          name: 'operation'
          , values: this.operations
        }
        ,{
          name: 'reason_name'
          , values: this.reasonNames
        }
        ,{
          name: 'employee'
          , values: this.employees
        }
        , {
          name: 'diagnostic_group'
          , values: this.diagnosticGroupsSelected
        }
      ]
    }
    ,parametersForFilters () {
      let values = {
        start_date: this.date.start
        ,end_date: this.date.end
      }
      this.listFilters.filter((element) => {
        if (element.values.length) { values[element.name] = element.values }
      })
      return values
    }
  }
  ,watch: {
    date : {
      handler(){
        this.getDateServer()
      }
      ,deep: true
    }
    ,sites: {
      handler() {
        if (
            this.sites.length
        ) {
          this.getDateServer()
        }
      }
      ,deep: true
    }
    ,operations:  {
      handler() {
        if (
            this.operations.length
        ) {
          this.getDateServer()
        }
      }
      ,deep: true
    }
    ,reasonNames: {
      handler() {
        if (
            this.reasonNames.length
        ) {
          this.getDateServer()
        }
      }
      ,deep: true
    }
    ,employees: {
      handler() {
        if (
            this.employees.length
        ) {
          this.getDateServer()
        }
      }
      ,deep: true
    }
  }
  ,async beforeMount () {
    this.processingTotalRecorded = true
    await this.getAbsenteeismTotalRecordedStore().finally(() => {
      this.processingTotalRecorded = false
    })
  }
  ,methods: {
    ...mapActions('healthTrackerAbsenteeismV2InformationManagementGraphic', [
         'getTypeAbsenteeismStore'
        , 'getAbsenceSenderStore'
        , 'getEmployeesStore'
        , 'getAbsenteeismTotalRecordedStore'
        , 'getDiagnosticGroupsStore'
        , 'getLostTimeStore'
    ])
    , getKeyLostTimes(key = 'month') {
      return this.getLostTimes.map((value) => value[key]??null)
    }
    , conditionsNoExist (key, processing) {
      if (!this.exists_date) return  { key: !this.exists_date, msj: 'Por favor seleccione las  fechas' }
      if (processing) return  { key: processing, msj: 'Cargando...'}
      if(!key && this.exists_date) return { key: !key, msj: 'No hay información' }
    }
    , async changedPageTypeAbsenteeismTable (page = 1)
    {
      let values = this.parametersForFilters
      values.reason_name = this.reasonNamesTypeAbsenteeism
      values.page = page
      this.processingTypeAbsenteeismTable = true
      await this.getEmployeesStore({ data: values, type: 'type-of-absenteeism' })
          .finally(() => {
            this.processingTypeAbsenteeismTable = false
          })
    }
    , async changedPageDiagnosticGroupsTable (page = 1)
    {
      let values = this.parametersForFilters
      values.page = page
      this.processingDiagnosticGroupsTable = true
      await this.getEmployeesStore({ data: values, type: 'diagnostic-groups' })
          .finally(() => {
            this.processingDiagnosticGroupsTable = false
          })
    }
    , clickInDiagnostic (id)
    {
      this.diagnosticGroupsSelected = [id]
      this.changedPageDiagnosticGroupsTable()
    }
    , clickInAbsenteeism (id)
    {
      this.diagnosticGroupsSelected = []
      this.reasonNamesTypeAbsenteeism = [id]
      this.changedPageTypeAbsenteeismTable()
    }
    , async getDateServer ()
    {
      this.processingDiagnosticGroup = true
      this.processingTypeAbsenteeism = true
      this.processingAbsenceSender = true
      this.processing_lost_time = true
      /*
        parameters
       */
      const values = this.parametersForFilters
      this.errors = []

      /*
        get groups of diagnostic
       */
      await this.getDiagnosticGroupsStore(values)
          .catch(({ response: { data : { message }}}) => {
            this.errors = message
          }).finally(() => {
            this.processingDiagnosticGroup = false
          })

      /*
        get other queries
       */
      await this.getTypeAbsenteeismStore(values)
          .catch(({response: { data : { message }}}) => {
             this.errors = message
          })
          .finally(() => {
            this.processingTypeAbsenteeism = false
          })

      await this.getAbsenceSenderStore(values)
          .finally(() => {
            this.processingAbsenceSender = false
          })

      await this.getLostTimeStore(values)
          .catch(({ response: { data : { message }}}) => {
            this.errors = message
          }).finally(() => this.processing_lost_time = false )
    }
    , changedEmployees (values = [])
    {
      this.employees = values
      this.diagnosticGroupsSelected = []
    }
    , changedOperations (values = [])
    {
      this.operations = values
      this.diagnosticGroupsSelected = []
    }
    , changedSites (values = [])
    {
      this.sites = values
      this.diagnosticGroupsSelected = []
    }
    , changedReasonNames (values = [])
    {
      this.reasonNames = values
      this.diagnosticGroupsSelected = []
    }
    , changedDate ({ startDate, endDate })
    {
      this.date.start = startDate
      this.date.end = endDate
    }
    , forgetFilters ({ startDate, endDate }) {
      this.date.start = startDate
      this.date.end = endDate
      this.changedEmployees()
      this.changedOperations()
      this.changedSites()
      this.changedReasonNames()
      this.getDateServer()
    }
  }
}
</script>
<style lang="scss">
h1{
  width: auto;
  height: auto;
}

.content-generic {
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 30px 30px 0 30px;
  margin: 30px 0;
  display: block;
}
.content-total{
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  display: inline-block;
  margin-top: 2.5rem;
  padding: 10px 15px;
}
.card-body {
  padding: 0;
}
.card_scroll {
  border: 0 !important;
  border-radius: 0;
  box-shadow: none !important;
}
.card_scroll .card-header {
  padding: 0;
  margin-bottom: 0;
  background-color: transparent !important;
  border-bottom: 0;
  display: block;
  text-align: center;
// border-radius: 48px;
}
.toggle-tab {
    ul {
      padding: 4px;
      background: #FFFFFF;
      border: 1px solid #C9CAFF;
      box-sizing: border-box;
      border-radius: 48px;
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0.5px 0.5px;
      width: max-content;
    }
    li {
      padding: 3px 12px;
      a {
        font: normal normal 300 14px/22px 'Ubuntu';
        color: #000000;
        transition: all 0.3s ease;
      }
      a:hover, a.active {
        bottom: 0%;
        border-radius: 100px;
        flex-grow: 0;
        color: #FFFFFF !important;
        background-color: #5D5FEF;
      }
    }
}
</style>